var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('SideMenu',{attrs:{"submenuPage":"Dashboard"}},[_c('div',[_c('h1',[_vm._v("404 - Page Not Found")]),_c('p',[_vm._v("The page you are looking for does not exist.")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }